<template>
  <div class="index">
    <success-show v-if="isLoggedIn"></success-show>
    <template v-else>
      <div class="top">
        <img src="./img/top.jpg" alt="" />
        <div class="text-box">
          <div class="left">客户案例</div>
          <div class="bottom">覆盖19个省，30多个重点城市</div>
        </div>
        <ul class="ul">
          <li class="li" v-for="(item, index) in list" :key="index" @click="jump(item)" :class="route === item.route ? 'checked' : ''">
            <div class="li-text">
              {{ item.name }}
            </div>
          </li>
        </ul>
      </div>
      <router-view @show-success="showSuccess"></router-view>
    </template>
  </div>
</template>

<script>
import { enableCasePreview, getToken } from '@/utils/auth';
import SuccessShow from './components/SuccessShow.vue';

export default {
  name: 'index',
  components: {
    SuccessShow
  },
  data() {
    return {
      list: [
        {
          name: '数字乡村',
          route: '/case/smartVillage'
        },
        {
          name: '智慧园区',
          route: '/case/smartPark'
        },
        {
          name: '智慧城市',
          route: '/case/wisdomCity'
        },
        {
          name: '智慧景区',
          route: '/case/smartSpot'
        }
      ]
    };
  },
  computed: {
    route() {
      return this.$route.path;
    },
    isLoggedIn() {
      return !!getToken();
    }
  },
  watch: {},
  methods: {
    jump(item) {
      let { fullPath } = this.$route;
      if (!item.route) {
        return;
      }
      if (fullPath === item.route) {
        return;
      }
      this.$router.push({
        path: item.route
      });
    },
    showSuccess() {
      if (getToken()) {
        enableCasePreview();
      }
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.index {
  .top {
    position: relative;
    img {
      width: 100%;
      height: 710px;
    }
    .text-box {
      width: 620px;
      color: #fff;
      font-size: 70px;
      position: absolute;
      top: 40%;
      left: 55%;
      transform: translate(-50%, -50%);
      .left {
        text-align: left;
      }
      .bottom {
        margin-left: 60px;
        margin-top: 50px;
        font-size: 28px;
      }
    }
    .ul {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 98px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .li {
        font-size: 28px;
        cursor: pointer;
        color: #fff;
        font-family: 'PingFang';
        &:hover {
          color: #f15030;
        }
      }
    }
    .checked {
      .li-text {
        color: #f15030;
      }
      &::before {
        width: 100%;
      }
    }
  }
}
</style>
